import React from 'react';
import PhoneInput from 'react-phone-number-input';
import de from 'react-phone-number-input/locale/de';
import 'react-phone-number-input/style.css';
import Card from '../../components/cards/Card';
import { Button } from '../../components';
import { Text, TouchableOpacity, View } from 'react-native';
import { BERRY } from '../../settings/colors';
import { useHistory } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { requestVerificationCode } from '../../store/actions/auth';
import AuthLayout from '../../components/layouts/AuthLayout.web';
import './phoneInput.css';

function LogIn() {
  const [email, setEmail] = React.useState('');
  const [phone, setPhone] = React.useState('');
  const [error, setError] = React.useState(null);
  const [focus, setFocus] = React.useState(null);
  const [isLoading, setLoading] = React.useState(false);
  const history = useHistory();
  const dispatch = useDispatch();
  return (
    <AuthLayout>
      <Card>
        <Text
          style={{
            fontSize: 'xx-large',
            fontWeight: 'bold',
            marginBottom: 20,
            textAlign: 'center',
          }}
        >
          Anmelden
        </Text>
        {error && <Text style={{ color: 'red' }}>{error}</Text>}
        <View style={{ alignItems: 'stretch', marginBottom: 20 }}>
          <input
            placeholder="E-Mail-Adresse"
            value={email}
            onFocus={() => {
              setFocus('email');
              setPhone('');
            }}
            onChange={event => setEmail(event.target.value)}
            style={{ opacity: focus === 'phone' ? 0.3 : 1 }}
          />
          <Text
            style={{
              marginVertical: 20,
              fontSize: 'large',
              textAlign: 'center',
              opacity: focus ? 0.3 : 1,
            }}
          >
            oder
          </Text>
          <View>
            <PhoneInput
              displayInitialValueAsLocalNumber
              placeholder="Handynummer"
              value={phone}
              onChange={setPhone}
              onFocus={() => {
                setFocus('phone');
                setEmail('');
              }}
              defaultCountry="CH"
              style={{ opacity: focus === 'email' ? 0.3 : 1 }}
              labels={de}
            />
          </View>
        </View>
        <Button
          text="Weiter"
          action={async () => {
            setLoading(true);
            const identifier = email.length > 0 ? email : phone;
            await dispatch(requestVerificationCode(identifier, 'login'))
              .then(() => {
                history.push('/verify', { identifier });
              })
              .catch(e => {
                setError(
                  email.length > 0
                    ? 'Kein Konto mit dieser E-Mail-Adresse gefunden.'
                    : 'Kein Konto mit dieser Handynummer gefunden.',
                );
              })
              .finally(() => setLoading(false));
          }}
          size="large"
          type="primary"
          isLoading={isLoading}
        />
      </Card>
      <TouchableOpacity onPress={() => history.push('/register')}>
        <Text style={{ color: BERRY }}>Kein Konto? Jetzt eines erstellen.</Text>
      </TouchableOpacity>
    </AuthLayout>
  );
}

export default LogIn;
